import { FormControl, FormGroup } from '@angular/forms';
import { SourceType } from '@src/api/reports';
import { KeyValueArrayFormType, KeyValueArrayFormDataType } from '@src/app/modules/key-value-array';

export interface FormDataType {
  type: SourceType;
  defaultValue: any | null; // TODO: другой тип
  driver: string | null;
  username: string | null;
  password: string | null;
  query: string | null;
  uri: string | null;
  method: string | null;
  headers: KeyValueArrayFormDataType;
  body: KeyValueArrayFormDataType;
}

export interface FormType {
  type: FormControl<SourceType>;
  defaultValue: FormControl<any | null>; // TODO: другой тип
  driver: FormControl<string | null>;
  username: FormControl<string | null>;
  password: FormControl<string | null>;
  query: FormControl<string | null>;
  uri: FormControl<string | null>;
  method: FormControl<string | null>;
  headers: FormGroup<KeyValueArrayFormType>;
  body: FormGroup<KeyValueArrayFormType>;
}

export type Methods = 'GET' | 'POST';
export const Methods = {
  GET: 'GET' as Methods,
  POST: 'POST' as Methods,
};

export type SourceTypes = SourceType;
export const SourceTypes = SourceType;

export type DefaultValues = 'now()';
export const DefaultValues = {
  Now: 'now()' as DefaultValues,
};

export type HeadersKeys = 'Authorization';
export const HeadersKeys = {
  Authorization: 'Authorization' as HeadersKeys,
};

export type TextTemplates = '{{auth.token}}' | '{{report.uuid}}' | '{{filter.id}}' | '{{filter.name}}';
export const TextTemplates = {
  AuthToken: '{{auth.token}}' as TextTemplates,
  ReportUuid: '{{report.uuid}}' as TextTemplates,
  FilterId: '{{filter.id}}' as TextTemplates,
  FilterName: '{{filter.name}}' as TextTemplates,
};

export const HeadersValues = {
  Bearer: `Bearer ${TextTemplates.AuthToken}`,
};

export const BindingSourceEndpoints = {
  ReportUuidFilterId: `/reports/${TextTemplates.ReportUuid}/filters/${TextTemplates.FilterId}/values`,
  ReportUuidFilterName: `/reports/${TextTemplates.ReportUuid}/filters/${TextTemplates.FilterName}/values`,
};
